import React from 'react';
type PlaceholderProps = {
  label: string;
  className?: string;
  style?: React.CSSProperties;
  ratio?: string;
};
export function Placeholder({
  label,
  className = '',
  style,
  ratio = '3 / 4'
}: PlaceholderProps) {
  return <div className={`flex items-center justify-center bg-[#dcdcdc] text-center text-[10px] font-medium uppercase tracking-[0.14em] text-[#5a5a5a] ${className}`} style={{
    aspectRatio: ratio,
    ...style
  }} role="img" aria-label={label} data-id="element-54" data-mp="3khyfrcw34tn7">
      {label}
    </div>;
}